function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function(key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
import { Collector } from "@dp/byted-tea-sdk-oversea";
import { DEFAULT_TEA_APP_ID, DEFAULT_TEA_CONFIG } from "../constants";
const teaInstance = typeof window !== "undefined" ? new Collector("cookie_banner_tea_sdk") : null;
let teaInited = false;
function initTea(teaConfig) {
  if (teaInited || !teaInstance) {
    return;
  }
  teaInited = true;
  const config = teaConfig !== null && teaConfig !== void 0 ? teaConfig : DEFAULT_TEA_CONFIG;
  teaInstance.init(_object_spread({
    app_id: DEFAULT_TEA_APP_ID
  }, config));
  teaInstance.start();
}
function teaReport(eventName, attributes = {}) {
  if (!teaInited || !teaInstance) {
    return;
  }
  const referrer = `${location.protocol}//${location.host}${location.pathname}`;
  teaInstance.event(eventName, _object_spread({
    page_url: referrer,
    host: location.host,
    user_agent: navigator.userAgent,
    referrer,
    loader_version: "1.0.1"
  }, attributes));
}
function loadScript(url) {
  const scriptEle = document.createElement("script");
  scriptEle.src = url;
  teaReport("cookie_banner_cdn_load", {
    resource_url: url
  });
  scriptEle.crossOrigin = "anonymous";
  scriptEle.onerror = () => teaReport("cookie_banner_cdn_load_failed", {
    resource_url: url
  });
  document.body.appendChild(scriptEle);
}
function isSSR() {
  return typeof window === "undefined";
}
export {
  initTea,
  isSSR,
  loadScript,
  teaReport
};
